module.exports = __webpack_public_path__ + "static/media/CarryOn_LargeLaggage_Arrows_iOS12Fix.992f6cb0.usdz";